import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`periodos?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getByUser(keyword, pageNumber, sort, id) {
        return Api().get(`periodos/user?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}&id=${id}`);
    },
}